module.exports = __webpack_public_path__ + "img/gsjs_card.4563dc13.png";